<template>
  <div class="fixed" style="right: 30px; top: 25px;">
    <div>
      <toast
        class="mb-4"
        v-for="toast in toasts"
        :key="toast.id"
        :toast="toast"
      />
    </div>
  </div>
</template>

<script>
import Toast from "./Toast";

export default {
    components: { Toast },
    props: {},
    computed: {
        toasts() {
            return this.$store.getters["notification/toasts"];
        }
    }
};
</script>

<style scoped></style>
